"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractVersion = void 0;
class ContractVersion {
    constructor(deployedContracts) {
        this.deployedContracts = deployedContracts;
    }
    // @dev: the current version defaults to version of last contract in deployedContracts
    get version() {
        return this.deployedContracts[this.deployedContracts.length - 1].version;
    }
    get deployedContractsByVersion() {
        return this.deployedContracts.reduce((acc, deployedContract) => {
            acc[deployedContract.version] = deployedContract;
            return acc;
        }, {});
    }
    get versions() {
        return Object.keys(this.deployedContractsByVersion);
    }
    get deployedContract() {
        return this.deployedContractsByVersion[this.version];
    }
    get abi() {
        return this.deployedContract.abi;
    }
    addressByNetwork(network) {
        return this.addressByNetworkForContract(network, this.deployedContract);
    }
    addressesByNetwork(network) {
        return this.versions.map((version) => this.addressByNetworkForVersion(network, version));
    }
    addressByNetworkForVersion(network, version) {
        return this.addressByNetworkForContract(network, this.deployedContractsByVersion[version]);
    }
    addressByNetworkForContract(network, deployedContract) {
        // Default to multichain address if available. 0 here means the address is multichain.
        if (0 in deployedContract.addresses) {
            return deployedContract.addresses[0].toLowerCase();
        }
        const address = deployedContract.addresses[network];
        if (address) {
            return address.toLowerCase();
        }
        throw new Error("Unknown network");
    }
    addressesForContract(deployedContract) {
        return Object.values(deployedContract.addresses).map((address) => address.toLowerCase());
    }
    get abiByAddress() {
        return Object.keys(this.deployedContractsByVersion).reduce((acc, version) => {
            const deployedContract = this.deployedContractsByVersion[version];
            for (const address of this.addressesForContract(deployedContract)) {
                acc[address] = deployedContract.abi;
            }
            return acc;
        }, {});
    }
    getAbiByAddress(address) {
        return this.abiByAddress[Object.keys(this.abiByAddress).find((a) => a.toLowerCase() === address.toLowerCase())];
    }
    getVersionByAddress(address) {
        if (!this.isKnownAddress(address)) {
            throw new Error("Unknown address");
        }
        return Object.keys(this.deployedContractsByVersion).find((version) => {
            const deployedContract = this.deployedContractsByVersion[version];
            return this.addressesForContract(deployedContract).includes(address.toLowerCase());
        });
    }
    isKnownAddress(address) {
        return Boolean(this.getAbiByAddress(address));
    }
}
exports.ContractVersion = ContractVersion;
//# sourceMappingURL=ContractVersion.js.map